<template>
  <div class="inline-block">
    <vs-button
      color="primary"
      type="border"
      icon="edit"
      @click="activeWindow=true"
    />
    <vs-popup
      class="holamundo"
      title="Редактирование параметров"
      :active.sync="activeWindow"
    >
      <template v-if="localImage">

        <!-- Image Container -->
        <div class="img-container w-64 mx-auto flex items-center justify-center">
          <img
            :src="localImage"
            alt="img"
            class="responsive"
          >
        </div>

        <!-- Image upload Buttons -->
        <div class="modify-img flex justify-between mt-5">
          <input
            ref="updateImgInput"
            type="file"
            class="hidden"
            accept="image/*"
            @change="updateCurrImg"
          >
          <vs-button
            class="mr-4"
            type="flat"
            @click="$refs.updateImgInput.click()"
          >Заменить
          </vs-button>
          <vs-button
            type="flat"
            color="#999"
            @click="localImage = null"
          >
            Удалить
          </vs-button>
        </div>
      </template>

      <div
        v-else
        class="upload-img mt-5"
      >
        <input
          ref="uploadImgInput"
          type="file"
          class="hidden"
          accept="image/*"
          @change="updateCurrImg"
        >
        <vs-button @click="$refs.uploadImgInput.click()">
          Загрузить изображение
        </vs-button>
      </div>
      <div class="inline-block mt-5">
        <vs-input-number
          v-model="localCount"
          min="0"
          class="mt-5"
          @input="$emit('update:count', localCount)"
        />
      </div>
      <vs-input
        v-model="localEnterPrice"
        icon-pack="fas"
        icon="fa-ruble-sign"
        label="Входящая цена"
        class="mt-5 w-full"
        @input="$emit('update:enterPrice', localEnterPrice)"
      />
      <vs-input
        v-model="localOldPrice"
        icon-pack="fas"
        icon="fa-ruble-sign"
        label="Старая цена"
        class="mt-5 w-full"
        @input="$emit('update:oldPrice', localOldPrice)"
      />
      <vs-input
        v-model="localPrice"
        icon-pack="fas"
        icon="fa-ruble-sign"
        label="Цена"
        class="mt-5 w-full"
        name="item-price"
        @input="$emit('update:price', localPrice)"
      />
    </vs-popup>
  </div>
</template>

<script>
import axios from '@axios'

export default {
  name: 'ProductPrices',
  props: [
    'enterPrice',
    'price',
    'oldPrice',
    'image',
    'count',
  ],
  data() {
    return {
      activeWindow: false,
      localPrice: this.price,
      localOldPrice: this.oldPrice,
      localEnterPrice: this.enterPrice,
      localImage: this.image,
      localCount: this.count,
    }
  },
  methods: {
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.readAsDataURL(input.target.files[0])
        const formData = new FormData()
        formData.append('image', input.target.files[0])
        axios.post('shop/products/files/add',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }).then(function (response) {
          this.$vs.notify({
            color: 'success',
            title: 'Успешная загрузка',
            text: 'Изображение было успешно загружено',
          })
          this.localImage = response.data.url
          this.$emit('update:image', this.localImage)
        })
          .catch(function () {
            this.$vs.notify({
              color: 'danger',
              title: 'Ошибка загрузки',
              text: 'Изображение не было загружено',
            })
          })
      }
    },
  },
}
</script>
